import { Injectable, inject } from '@angular/core';

import { WidgetType } from '@frontend/sports/types/components/widget';
import { WidgetRegistryService } from '@frontend/sports/widget/core/feature';
import { OnFeatureInit } from '@frontend/vanilla/core';

import { StoryContentComponent } from './story-content.component';

@Injectable({ providedIn: 'root' })
export class StoryContentWidgetRegistration implements OnFeatureInit {
    private widgetRegistry = inject(WidgetRegistryService);

    onFeatureInit(): void {
        this.widgetRegistry.registerLazy(WidgetType.StoryContent, StoryContentComponent);
    }
}
